import Brush from '../../../../assets/icons/drawingTools/brush'
import CircleIcon from '../../../../assets/icons/drawingTools/circle'
import EllipseIcon from '../../../../assets/icons/drawingTools/ellipse'
import PathIcon from '../../../../assets/icons/drawingTools/path'
import PolyLineIcon from '../../../../assets/icons/drawingTools/polyLine'
import RectangleIcon from '../../../../assets/icons/drawingTools/rectangle'
import RotatedRectangleIcon from '../../../../assets/icons/drawingTools/rotatedRectangle'
import TriangleIcon from '../../../../assets/icons/drawingTools/triangle'
import { DrawingToolMenuItem } from './drawingToolMenu'

export const shapesToolMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'brush',
        text: 'Brush',
        icon: <Brush />,
        drawingType: 'brush',
        toolOptions: {}
    },
    {
        drawingToolId: 'rectangle',
        text: 'Rectangle',
        icon: <RectangleIcon />,
        drawingType: 'rectangle',
        toolOptions: {}
    }, {
        drawingToolId: 'ellipse',
        text: 'Ellipse',
        icon: <EllipseIcon />,
        drawingType: 'ellipse',
        toolOptions: {}
    }, {
        drawingToolId: 'triangle',
        text: 'Triangle',
        icon: <TriangleIcon />,
        drawingType: 'triangle',
        toolOptions: {}
    }, {
        drawingToolId: 'circle',
        text: 'Circle',
        icon: <CircleIcon />,
        drawingType: 'circle',
        toolOptions: {}
    }, {
        drawingToolId: 'path',
        text: 'Path',
        icon: <PathIcon />,
        drawingType: 'path',
        toolOptions: {
            showLineHead: true
        }
    }, {
        drawingToolId: 'path',
        text: 'Polyline',
        icon: <PolyLineIcon />,
        drawingType: 'polyLine',
        toolOptions: {
            showLineHead: false
        }
    }, {
        drawingToolId: 'rotatedRectangle',
        text: 'Rotated Rectangle',
        icon: <RotatedRectangleIcon />,
        drawingType: 'rotatedRectangle',
        toolOptions: {}
    }
]